import DashboardView from "./view";

const Dashboard = ({ children = <></> }) => {
  return <DashboardView children={children} />;
};


export default Dashboard;
